//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

//custom pages
import "assets/css/custom.css";
import useForm from "helpers/useForm";
import { emailValidate } from "helpers/validateRules/auth";
import auth from "apis/auth/auth";
import SignupParent from "components/AuthPages/SignupParent";
import { signUpEmailStyles } from "./styles";

// material-ui
import {
  ThemeProvider,
  withStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
// material-ui icons
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#fff",
    },
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#fff",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
})(TextField);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

const toastCss = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

const initialValues = {
  email: "",
};

export default function SignupEmail() {
  const history = useHistory();
  const { verifyEmail } = auth();
  const classes = signUpEmailStyles();

  const [states, setstates] = useState({
    tooltipName: "",
    tooltipCondition: false,
    disableButton: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // handling inputs
  const { values, errors, handleSubmit, handleChange, setUpdateValue } =
    useForm(initialValues, handleVerifyEmail, emailValidate);

  // verify email func
  async function handleVerifyEmail() {
    // let emailDomain = values.email.slice(values.email.indexOf('@') + 1);
    // if (emailDomain !== 'gmail.com') {
    // 	setStates({ disableButton: false });
    // 	return toast.error('Enter valid email address', toastCss);
    // }
    let res = await verifyEmail({ ...values, type: "Signup" });
    if (res && res.type == "success") {
      toast.success(res && res.message, toastCss);
      return history.push("/verify-signupotp", {
        emailResponse: { page: "signup", ...res },
      });
    }
    toast.error(
      res && res.message ? res.message : "something went wrong",
      toastCss
    );
    setStates({ disableButton: false });
  }

  return (
    <SignupParent>
      <React.Fragment>
        <div className={classes.signUpText}>Employee sign up</div>
        <div className={classes.inputMainDiv}>
          <ThemeProvider theme={formLabelsTheme}>
            <CssTextField
              id="emailId"
              label="Official email ID"
              type={"email"}
              autoComplete="off"
              required
              fullWidth={true}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip
                      arrow
                      placement="top-start"
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      title="Enter the Email Id provided by Henry Schein authorities"
                      open={
                        states.tooltipName === "emailSignup" &&
                        states.tooltipCondition
                          ? true
                          : false
                      }
                    >
                      <IconButton
                        onClick={() =>
                          setStates({
                            tooltipName: "emailSignup",
                            tooltipCondition: !states.tooltipCondition,
                          })
                        }
                        className={classes.emailInputIconBtn}
                      >
                        <InfoOutlinedIcon className={classes.emailInputIcon} />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              value={values.email}
              onChange={(e) => {
                handleChange({ name: "email", value: e.target.value });
              }}
            />
          </ThemeProvider>
          {errors.email && <span className="error">{errors.email}</span>}
        </div>
        <div className={classes.btnDiv}>
          <Button
            variant="contained"
            className={classes.btn}
            disabled={states.disableButton}
            onClick={() => {
              handleSubmit();
              setStates({ disableButton: true });
            }}
          >
            Get OTP
          </Button>
        </div>
      </React.Fragment>
    </SignupParent>
  );
}
